import Mustache from "./mustache.min.js";
import $ from "jquery";

import scripts from "./scripts.js";
import generateMainSvgs from "./main-svg";

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

// async function getTemplate(component, templates) {
//   await $.ajax({
//     url: "./component-" + component + ".html",
//     cache: false,
//     async: false,
//     timeout: 500,
//     success: function (data) {
//       templates[component] = data;
//     },
//     error: function (err) {
//       console.log(err);
//     },
//     dataType: "html",
//   });
// }

async function getTemplate(component, templates) {
  try {
    const url = `./component-${component}.html?_=${Date.now()}`;
    const response = await fetch(url, {
      cache: "no-store",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "text/html, */*; q=0.01",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const data = await response.text();
    templates[component] = data;
  } catch (err) {
    console.error(err);
  }
}

// VARS
// const domain = "https://versicherungsmakler-burgwedel.de";
let domain = window.location.origin;
// const domainDevAPI = "https://zielke-versicherungsmakler.de";
const domainDevAPI = "https://versicherungsmakler-burgwedel.de";
if (domain.includes("localhost")) {
  domain = domainDevAPI;
}
const templates = {};
let contactInformation = "";
let footerLinks = [];
let navigationID = 0;
let headerCarouselInterval = 0;

// HEADER
async function ajaxHeader() {
  const url = `${domain}/api/api/singletons/get/header`;
  const response = await fetch(url);
  const data = await response.json();

  data.domain = domain;

  data.images.forEach((image) => {
    // preload
    const img = new Image();
    img.src = domain + image.value.image.path;
  });

  data.images[0].value.firstItem = true;
  data.images[0].value.active = true;
  headerCarouselInterval = parseInt(data.interval);

  // template laden
  await getTemplate("header", templates);

  const template = templates.header;
  const html = Mustache.render(template, data);
  $(html).insertBefore(".maincontent");

  // social icons
  data.socialmedia.forEach((item) => {
    $(".nav-item.social-icons").append(`
      <div class="social-icons__icon">
        <a title="${item.value.plattform}" href="${item.value.link}" target="blank">
          <img src="./${item.value.plattform}.png" alt="">
        </a>
      </div>
    `);
  });
}
// END HEADER
// FOOTER
async function ajaxFooter() {
  try {
    const response = await fetch(`${domain}/api/api/singletons/get/footer`, {
      headers: {
        Accept: "application/json, */*; q=0.01",
        "X-Requested-With": "XMLHttpRequest",
      },
      cache: "no-store",
    });

    if (!response.ok) {
      throw new Error(`Footer request failed: ${response.status}`);
    }

    const data = await response.json();

    // Daten wie zuvor anreichern
    data.domain = domain;
    data.links = data.links.filter((link) => link.value.active);

    footerLinks = data.links;
    contactInformation = data.contact;

    // Template laden
    await getTemplate("footer", templates);
    const template = templates.footer;

    const html = Mustache.render(template, data);

    // ins DOM einfügen
    $(html).insertAfter(".maincontent");
  } catch (err) {
    console.error("Footer error:", err);
  }
}

// END FOOTER

// MAIN

async function ajaxMain() {
  try {
    const url = `${domain}/api/api/singletons/get/maincontent?populate=3`;

    const response = await fetch(url, {
      headers: {
        Accept: "application/json, */*; q=0.01",
        "X-Requested-With": "XMLHttpRequest",
      },
      cache: "no-store",
    });

    if (!response.ok) {
      throw new Error(`Maincontent request failed: ${response.status}`);
    }

    const data = await response.json();

    // Haupt-Loop für alle Layout-Elemente
    for (const layoutEl of data.layout) {
      // ============= TEMPLATE LADEN (falls nicht bereits im Cache) =============
      if (layoutEl.component !== "text") {
        if (!templates[layoutEl.component]) {
          await getTemplate(layoutEl.component, templates);
        }
      }

      const template = templates[layoutEl.component];
      if (!template) continue;

      // =========================================================================
      //                              TEXTMEDIA EXTRA
      // =========================================================================
      if (layoutEl.component === "textmedia") {
        const settings = layoutEl.settings;

        if (settings.text || settings.headline || settings.title) {
          settings.hasText = true;
        }

        if (!settings.image_small) delete settings.image_small;
        if (!settings.headlines_fix_on_top)
          delete settings.headlines_fix_on_top;

        // alignment classes
        switch (settings.image_align) {
          case "Bild rechts / Text links":
            settings.image_align_class = "custom-textmedia--img-right";
            break;
          case "Bild links / Text rechts":
            settings.image_align_class = "custom-textmedia--img-left";
            break;
          case "Vollbild / Text unten":
            settings.image_align_class =
              "custom-textmedia--img-full-text-bottom";
            break;
          case "Vollbild / Text oben":
            settings.image_align_class = "custom-textmedia--img-full-text-top";
            break;
        }

        // select image matching current domain
        let currentImageToDisplay = null;

        if (settings.image_domains && settings.image_domains.length > 0) {
          const domainWithImage = settings.image_domains.find(
            (el) => el.value.domainName.display === domain,
          );
          if (domainWithImage) {
            currentImageToDisplay = domainWithImage.value.image;
          }
        }

        if (!currentImageToDisplay) currentImageToDisplay = settings.image;
        if (currentImageToDisplay)
          settings.currentImageToDisplay = currentImageToDisplay;
      }

      // =========================================================================
      //                                INFOBOX EXTRA
      // =========================================================================
      if (layoutEl.component === "infobox") {
        layoutEl.settings.box = layoutEl.settings.box.filter(
          (box) => box.value.active,
        );
      }

      // =========================================================================
      //                               SERVICES EXTRA
      // =========================================================================
      if (layoutEl.component === "services") {
        const settings = layoutEl.settings;

        settings.services = settings.services.filter(
          (service) => service.value.active,
        );

        // generate categories
        settings.categories = settings.services.map((service) => ({
          label: service.value.category.display,
          categoryID: service.value.category.display
            .toLowerCase()
            .replace(/ /g, ""),
        }));

        // remove duplicates
        settings.categories = [
          ...new Map(
            settings.categories.map((item) => [item.label, item]),
          ).values(),
        ];

        // enhance each service
        settings.services.forEach((service, idx) => {
          service.value.modalID = "service-" + idx;

          if (service.value.showInAll === undefined) {
            service.value.showInAll = true;
          }
          if (!service.value.showInAll) delete service.value.showInAll;

          service.value.categoryID = settings.categories.find(
            (cat) => cat.label === service.value.category.display,
          ).categoryID;
        });
      }

      // =========================================================================
      //                               TEMPLATE RENDER
      // =========================================================================
      layoutEl.settings.domain = domain;

      if (!layoutEl.settings.backgroundcolor) {
        layoutEl.settings.backgroundcolor = { color: "rgb(255,255,255)" };
      }

      const html = Mustache.render(template, layoutEl.settings);

      const $section = $(html)
        .appendTo(".maincontent")
        .filter("section.main-component")
        .first();
      $section.attr(
        "data-nav-visible",
        !!(
          layoutEl.settings.navigation_active &&
          layoutEl.settings.navigation_title
        ),
      );

      // =========================================================================
      //                            NAVIGATION ITEMS
      // =========================================================================
      if (
        layoutEl.settings.navigation_active &&
        layoutEl.settings.navigation_title
      ) {
        $section.attr("id", "nav" + navigationID);

        $(".navbar-nav").append(`
          <li class="nav-item">
            <a class="nav-link page-scroll" href="#nav${navigationID}">
              ${layoutEl.settings.navigation_title}
            </a>
          </li>
        `);
        navigationID++;
      }
    }
  } catch (err) {
    console.error("Maincontent error:", err);
  }
}

(async function () {
  await Promise.all([ajaxHeader(), ajaxMain(), ajaxFooter()]);

  scripts();
  if (window.location.hash) {
    var hash = window.location.hash;
    $(hash).modal("toggle");
  }
  // init carousel
  $("#headerCarousel").addClass("carousel");
  $("#headerCarousel").carousel({
    interval: headerCarouselInterval,
    ride: "carousel",
  });

  // init contact form agreement footer links
  $(".js-contacts-agreement").each((index, el) => {
    let htmlStr = el.innerHTML;
    const matchedLinks = footerLinks.filter(
      (footerLink) => htmlStr.indexOf(footerLink.value.title) !== -1,
    );
    matchedLinks.forEach((link) => {
      htmlStr = htmlStr.replace(
        link.value.title,
        `<a href="#" data-toggle="modal" data-target="#${link.value.title}">${link.value.title}</a>`,
      );
    });
    $(el).html(htmlStr);
  });

  // contact form send
  $(".custom-contactform form").on("submit", function (e) {
    e.preventDefault();
    const submitBtn = $(this).find('button[type="submit"]');
    const submitBtnPrevText = submitBtn.text();

    submitBtn.attr("disabled", "disabled");
    submitBtn.text("Bitte Warten");

    $.post(
      domain +
        "/api/api/forms/submit/contactform?token=c168e78ddc02529aed4a3f1da35439",
      { form: Object.fromEntries(new URLSearchParams($(this).serialize())) },
      () => {
        $(".form-message__success").removeClass("d-none");
        $('input[name="agreed"]').prop("checked", false);
        $('input[name="name"]').val("");
        $('input[name="telefon"]').val("");
        $('textarea[name="text"]').val("");
        $('input[name="email"]').val("");
        setTimeout(() => {
          submitBtn.text(submitBtnPrevText);
          submitBtn.removeAttr("disabled");
        }, 2000);
      },
    ).fail(function () {
      $(".form-message__error").removeClass("d-none");
      submitBtn.text(submitBtnPrevText);
      submitBtn.removeAttr("disabled");
    });
  });

  // add eventListener for services -> show contact info
  $(".js-services-show-contact-info").on("click", function () {
    const checkMailRegEx =
      /\b([\w\d.-]+(@)[\w\d.-]+([dot]|(dot)|.)[\w\d.-])+\b/g;
    const checkAtRegEx = /\b(\s*ät\s*|\s*\(ät\)\s*|\s*\(&auml;t\)\s*)+\b/g;
    let updatedContactInformation = contactInformation.replace(
      checkAtRegEx,
      "@",
    );
    const mail = updatedContactInformation.match(checkMailRegEx)[0];
    updatedContactInformation = updatedContactInformation.replace(
      mail,
      `<a href="mailto:${mail}">${mail}</a>`,
    );
    $(this).replaceWith(
      `<div class="services-contact-info">${updatedContactInformation}</div>`,
    );
  });

  // initial click on services ("alle")
  $('[data-filter=".show-in-all"]').trigger("click");

  // add main svgs
  generateMainSvgs();

  window.addEventListener(
    "resize",
    debounce(() => {
      generateMainSvgs();
    }, 100),
  );
})();
